import React, { useEffect } from 'react';
import { useTitle } from "../../../contexts/title";
import CFINoteGrid from '../../../features/dealer/notes/components/CFINoteGrid';

export default function CFINotesPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Notes')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<CFINoteGrid />
			</div>
		</React.Fragment>
	)
} 
